<div
    class="table-values-component dsn-scrollbar scroll-light full-height {{
        !isMobile() && 'desktop'
    }}"
    [class.device-desktop]="!isMobile()"
    [class.device-mobile]="isMobile()"
    fxLayout="column"
>
    @for (row of table(); track $index) {
        <div
            class="table-values-component__card"
            fxLayout="column"
            [attr.data-date]="row.date"
        >
            <div
                class="table-values-component__card-header cursor-pointer"
                fxLayout="row"
                (click)="toggleRow(row)"
            >
                <span class="text-12-regular color-text-primary">{{
                    row.date
                }}</span>

                @if (
                    row.childrens.length <= 1 &&
                    row.childrens[0].results.length <= 1
                ) {
                    <span class="text-12-semi-bold color-text-primary">{{
                        row.childrens[0].results[0].value
                    }}</span>
                } @else {
                    <i
                        class="color-text-primary fa-solid"
                        [class.fa-chevron-down]="!expandedRows.get(row.date)"
                        [class.fa-chevron-up]="expandedRows.get(row.date)"
                    ></i>
                }
            </div>
            <div
                class="table-values-component__card-content"
                [class.expanded]="expandedRows.get(row.date)"
            >
                @for (children of row.childrens; track $index) {
                    <div fxLayout="column" style="gap: var(--spacing-8)">
                        <span class="text-12-semi-bold color-text-primary">{{
                            children.serie.props.name
                        }}</span>
                        @for (result of children.results; track $index) {
                            <div
                                class="table-values-component__card-content-result"
                                fxLayout="row"
                                fxLayoutAlign="start center"
                            >
                                <span
                                    class="result-legend"
                                    [class.is-comparation]="
                                        result.isComparation
                                    "
                                    [style.opacity]="
                                        result.isBudget || result.isProjection
                                            ? 0.5
                                            : 1
                                    "
                                    [style.background-color]="result.color"
                                ></span>
                                <span
                                    class="text-12-regular color-text-primary"
                                    >{{ result.label }}</span
                                >
                                <span fxFlex></span>
                                <span
                                    class="text-12-semi-bold color-text-primary"
                                    >{{ result.value }}</span
                                >
                            </div>
                        }
                    </div>
                    @if ($index !== row.childrens.length - 1) {
                        <div
                            class="table-values-component__card-content-divider"
                        ></div>
                    }
                }
            </div>
        </div>
    }
    <!-- } -->
</div>
